// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../ContactBand";

export default function ServiceBlockchainPage() {
  return (
    <main>
      <section className="page-hero svc-hero ground" data-en="SERVICE">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/services">サービス</Link>
            <span>ブロックチェーン事業開発</span>
          </nav>
          <div className="svc-hero-grid">
            <div>
              <p className="svc-label">Service 02</p>
              <h1 className="svc-title">ブロックチェーン事業開発</h1>
              <p className="svc-catch">
                ブロックチェーン領域の豊富な知見をもとに、プロダクトの企画から設計・開発、リリース後の成長までを一貫して手がけます。
              </p>
              <p className="svc-short">
                新しい事業やプロダクトを、構想段階から一緒に描きます。
              </p>
              <div className="hero-cta svc-hero-cta">
                <Link className="btn" to="/contact">
                  <img src="/assets/icn_paperplane.svg" alt="" />
                  無料相談
                </Link>
                <Link className="btn btn-sub" to="/services">
                  サービス一覧
                </Link>
              </div>
            </div>
            <div className="svc-img">
              <img
                className="svc-main-img"
                src="/assets/images/services/blockchain-main-photo.jpg"
                alt="高層ビル群をネットワークの線がつなぐイメージ"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="section svc-value">
        <div className="container">
          <h2 className="value-title">
            ブロックチェーンを、事業の新たな土台に。
          </h2>
          <p className="value-text">
            スマートコントラクトの設計から、Webアプリや決済の開発、リリース後の運用・改善、グロースまで。
            <br className="pc" />
            ブロックチェーンプロジェクトにおける事業の立ち上げから成長までを担ってきた知見を生かします。
          </p>
          <ul className="value-list">
            <li>新規事業の構想を、技術的に実現できる形に落とし込める</li>
            <li>NFTや暗号資産決済など、新しい価値の流通を事業に組み込める</li>
            <li>リリース後も運用・改善を重ね、事業を伸ばし続けられる</li>
          </ul>
        </div>
      </section>
      <section className="section ground svc-issue">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            こんなお悩みはありませんか<strong>Issues</strong>
          </h2>
          <ul className="issue-list">
            <li className="issue-card">
              <span className="issue-mark">?</span>
              <p>
                ブロックチェーンで新規事業を立ち上げたいが、
                <br />
                形にできるパートナーがいない
              </p>
            </li>
            <li className="issue-card">
              <span className="issue-mark">?</span>
              <p>
                企画はあるが、
                <br />
                技術的に実現できるか判断できない
              </p>
            </li>
            <li className="issue-card">
              <span className="issue-mark">?</span>
              <p>
                NFTや暗号資産決済を組み込みたいが、
                <br />
                進め方が分からない
              </p>
            </li>
          </ul>
          <p className="issue-answer">
            その悩み、LEAPS が<strong>企画から開発・運用まで</strong>
            一貫して解決します。
          </p>
        </div>
      </section>
      <section className="section svc-feat">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            このサービスの特徴<strong>Feature</strong>
          </h2>
          <div className="feat-rows">
            <div className="feat-row">
              <div className="feat-copy">
                <span className="feat-num">01</span>
                <h3>プロダクト企画</h3>
                <p>
                  ブロックチェーンを活かした事業・プロダクトを、構想段階から一緒に描きます。技術的に実現できるかの見極めも行います。
                </p>
              </div>
              <div className="feat-img">
                <div className="dg dg-merge">
                  <div className="dg-col">
                    <span className="dg-box">事業のアイデア</span>
                  </div>
                  <i className="dg-ar dg-ar-lg">→</i>
                  <div className="dg-col">
                    <span className="dg-box dg-j">ユースケース設計</span>
                    <span className="dg-box dg-j">ビジネスモデル</span>
                    <span className="dg-box dg-j">技術的な実現性</span>
                  </div>
                  <i className="dg-ar dg-ar-lg">→</i>
                  <div className="dg-hub dg-l">
                    <b>企画書・要件</b>
                    <small>開発できる形に</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="feat-row rev">
              <div className="feat-copy">
                <span className="feat-num">02</span>
                <h3>設計・開発</h3>
                <p>
                  スマートコントラクト、Webアプリ、暗号資産決済の連携などを、設計から開発まで手がけます。
                </p>
              </div>
              <div className="feat-img">
                <div className="dg dg-stack">
                  <div className="dg-layer">
                    <b>アプリ</b>
                    <small>Web・スマホ・EC（Shopify など）</small>
                  </div>
                  <div className="dg-layer dg-j">
                    <b>API</b>
                    <small>既存のアプリから使える形に</small>
                  </div>
                  <div className="dg-layer dg-l">
                    <b>スマートコントラクト</b>
                    <small>NFT・トークン・決済の仕組み</small>
                  </div>
                  <div className="dg-layer dg-l2">
                    <b>ブロックチェーン</b>
                    <small>Ethereum・Polygon・Base など</small>
                  </div>
                  <p className="dg-stack-note">
                    既存のサービスを崩さずに、必要な層だけを組み込みます
                  </p>
                </div>
              </div>
            </div>
            <div className="feat-row">
              <div className="feat-copy">
                <span className="feat-num">03</span>
                <h3>リリース後の成長</h3>
                <p>
                  リリース後も運用・改善を重ね、マーケティングを含めて事業の成長まで手がけます。
                </p>
              </div>
              <div className="feat-img">
                <div className="dg dg-cycle">
                  <div className="dg-ring">
                    <span className="dg-node dg-n1 dg-l">リリース</span>
                    <span className="dg-node dg-n2">利用データ<wbr />の計測</span>
                    <span className="dg-node dg-n3">改善・機能追加</span>
                    <span className="dg-node dg-n4">マーケ<wbr />ティング</span>
                    <span className="dg-center">
                      運用しながら
                      <br />
                      伸ばし続ける
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mid-cta">
            <p>
              打ち合わせでは、進め方や類似の事例をご紹介します。
              <br />
              お気軽にご相談ください。
            </p>
            <div className="hero-cta">
              <Link className="btn" to="/contact">
                <img src="/assets/icn_paperplane.svg" alt="" />
                無料相談
              </Link>
              <Link className="btn btn-sub" to="/services">
                サービス一覧
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className="section ground flow">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            支援の流れ<strong>Flow</strong>
          </h2>
          <ol className="flow-list flow-icons">
            <li>
              <span className="flow-num">01</span>
              <span className="flow-icon">1</span>
              <h3>ご相談・企画整理</h3>
              <ul>
                <li>現状と目標のヒアリング</li>
                <li>実現したいサービスの整理</li>
              </ul>
            </li>
            <li>
              <span className="flow-num">02</span>
              <span className="flow-icon">2</span>
              <h3>企画・設計</h3>
              <ul>
                <li>技術と進め方の選定</li>
                <li>サービス・システムの設計</li>
              </ul>
            </li>
            <li>
              <span className="flow-num">03</span>
              <span className="flow-icon">3</span>
              <h3>開発</h3>
              <ul>
                <li>スマートコントラクト・アプリの開発</li>
                <li>テスト</li>
              </ul>
            </li>
            <li>
              <span className="flow-num">04</span>
              <span className="flow-icon">4</span>
              <h3>リリース・運用</h3>
              <ul>
                <li>リリース・公開</li>
                <li>運用・保守と機能改善</li>
              </ul>
            </li>
          </ol>
        </div>
      </section>
      <section className="section svc-proof">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            このサービスの支援事例<strong>Case</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/hikky">
              <div className="case-img is-cover">
                <span className="cover-en">METAVERSE NFT</span>
                <span className="cover-ja">メタバース × NFT</span>
              </div>
              <p className="case-meta">メタバース事業会社</p>
              <h3>メタバース霊園の土地と遺品を、NFTで受け継げる仕組みに</h3>
              <div className="case-tags">
                <span>メタバース・エンタメ</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand />
    </main>
  );
}
